<script>
	import { nanoid } from "nanoid";

	import AddressAutoComplete from "./AddressAutoComplete.svelte";
	import TextInput from "./TextInput.svelte";
	import EmailInput from "./EmailInput.svelte";
	import PhoneInput from "./PhoneInput.svelte";
	import DatePicker from "./DatePicker.svelte";
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";

	export let isRegistrationUpdate = false;
	export let required = false;
	export let disabled = false;
	export let idPrefix = "a" + nanoid(0, 3);
	export let firstName;
	export let surname;
	export let dateOfBirth = null;
	export let emailAddress;
	export let phoneNumber;
	export let address = null;
	export let validator = null;
</script>

<FormRow>
	<FormColumn cols="6">
		<TextInput
			label="First name"
			{required}
			disabled={disabled || isRegistrationUpdate}
			bind:value={firstName}
			id="{idPrefix}_firstName"
		/>
	</FormColumn>
	<FormColumn cols="6">
		<TextInput
			label="Last name"
			{required}
			disabled={disabled || isRegistrationUpdate}
			bind:value={surname}
			id="{idPrefix}_surname"
		/>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn cols="6">
		<EmailInput
			label="Email address"
			{required}
			disabled={disabled || isRegistrationUpdate}
			bind:value={emailAddress}
			id="{idPrefix}_email"
		/>
	</FormColumn>
	<FormColumn cols="6">
		<PhoneInput
			label="Phone number"
			{required}
			disabled={disabled || isRegistrationUpdate}
			bind:value={phoneNumber}
			id="{idPrefix}_phone"
		/>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn cols="6">
		<DatePicker
			{required}
			disabled={disabled || isRegistrationUpdate}
			label="Date of birth"
			validator={validator}
			start={new Date(1921, 0, 1)}
			end={new Date()}
			placeholder="e.g. 01/05/1987"
			defaultHighlighted={new Date(1993,0,1)}
			bind:formattedSelected={dateOfBirth}
			openOnClass="calendar-icon"

			on:dateChange
			on:dateSelected
		/>
	</FormColumn>
</FormRow>

<AddressAutoComplete
	{idPrefix}
	bind:addressValid={address.addressValid}
	bind:manualEntry={address.manualEntry}
	bind:googlePlaceJson={address.googlePlaceJson}
	bind:formattedAddress={address.formattedAddress}
	bind:premise={address.premise}
	bind:subpremise={address.subpremise}
	bind:street={address.street}
	bind:suburb={address.suburb}
	bind:state={address.state}
	bind:postcode={address.postcode}
	bind:country={address.country}
	bind:lat={address.lat}
	bind:lng={address.lng}
	bind:placeId={address.placeId}
	bind:url={address.googleMapsUrl}
	disabled={disabled || isRegistrationUpdate}
	{required}
></AddressAutoComplete>
